import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CustomNewButton from 'components/NewDesign/CustomNewButton';
import HelpModal from 'components/NewDesign/HelpModal';
import PointsExplanationList from 'components/admin/PointsExplanationList';
import { ReactComponent as InfoCircleIcon } from 'assets/images/icon_info_circle.svg';

// The Meet Points page's "How are points calculated?" button and its help, in the page's top row beside
// Export (Doug, 2026-10-24, H9; it was in the athletes table's search row). The points lines are the
// server's (PointsExplanation), the same as the Meet Details points dialog's; a school's open with how
// its house points are worked out.
const MeetPointsHelp = ({ explanation = [] }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <CustomNewButton
        variant="outline"
        icon={<InfoCircleIcon />}
        onClick={() => setOpen(true)}
        customStyle={{ backgroundColor: '#fefce8' }}
      >
        How are points calculated?
      </CustomNewButton>

      <HelpModal open={open} title="Points Calculation & Tie-Breaking" onClose={() => setOpen(false)}>
        <h3>How Points Are Calculated</h3>
        <p>
          These are the points this meet gives each athlete, worked out the same way as the season&apos;s points.
        </p>
        <PointsExplanationList sections={explanation} />

        <h3>Tie-Breaking Rules</h3>
        <p>
          When athletes have the same total points, the following tie-breaking criteria are applied in order:
        </p>
        <ul>
          <li><strong>1st:</strong> Total Points (higher is better)</li>
          <li><strong>2nd:</strong> Number of 1st Place finishes (higher is better)</li>
          <li><strong>3rd:</strong> Number of places that score (higher is better)</li>
        </ul>
        <p>
          Athletes who remain tied after all criteria share the same place.
        </p>
      </HelpModal>
    </>
  );
};

MeetPointsHelp.propTypes = {
  // How the meet scores, in the server's words: PointsExplanationList's sections.
  explanation: PropTypes.arrayOf(PropTypes.object),
};

export default MeetPointsHelp;
